<template>
  <panel-layout
    id="loyalty-panel"
    :heading="heading"
    :info="info"
    :loading="!!(transactions && transactions.loading) || loading || false"
    :show-footer="false"
  >
    <template #actions-right>
      <o-dropdown
        placement="bottom-end"
        class="mr-1 mb-1"
      >
        <o-button
          flat
          size="slim"
          icon="ellipses"
        />

        <template #content>
          <o-dropdown-item v-if="customer" icon="loyaltyPoints" @click="handleLoyaltyPointBalance">
            {{ $t('pages.customer.loyalty.id.edit') }}
          </o-dropdown-item>

          <o-dropdown-item v-if="customer" icon="refresh" @click="handleLoyaltyPointRecalculate">
            {{ $t('pages.customer.loyalty.id.recalculate') }}
          </o-dropdown-item>
        </template>
      </o-dropdown>
    </template>

    <div v-if="customer" class="h-full p-4 flex flex-col">
      <o-table
        v-if="transactions"
        class="border rounded"
        :data="transactions"
        :headers="[
          {text: $t('general.type')},
          {text: $t('general.amount')},
          {text: $t('general.date')},
          {text: $t('general.sale')}
        ]"
        :limit="20"
        :tbody-class="{
          tfoot: '',
          tr: 'transition-all duration-200 bg-gray-50 dark:bg-gray-900',
          td: 'py-3 px-4 text-gray-800 text-sm dark:text-gray-100',
          stripe: 'bg-gray-50/50 dark:bg-gray-900'
        }"
        :thead-class="{
          thead: 'border-b',
          tr: 'border-blue-700',
          th: 'font-normal p-4 pb-3 bg-gray-50 text-gray-700 text-sm sticky top-0 dark:bg-gray-900 dark:text-gray-200',
          content: 'flex item-center'
        }"
        striped
        scroll
      >
        <template #row="{ row, tdClass }">
          <td :class="tdClass">
            {{ row.type ? $t(LoyaltyTransactionTypeLabels[row.type]) : '-' }}
          </td>
          <td :class="tdClass">
            {{ row.amount }}
          </td>
          <td :class="tdClass">
            {{ formatDate(row.date) }}
          </td>
          <td :class="tdClass">
            <template v-if="row.order">
              {{ row.order.orderNumber }}

              <o-panel-link :path="`/order/${row.order.idOrder}`" tag="o-button" size="sm" flat class="ml-3">
                {{ $t('general.view') }}
              </o-panel-link>
            </template>

            <template v-else>
              -
            </template>
          </td>
        </template>
      </o-table>
    </div>

    <loyalty-point-balance-dialog
      v-if="customer"
      ref="loyaltyPointBalanceDialog"
      :customer="customer"
      @success="transactions.reload()"
    />

    <loyalty-point-recalculate-dialog
      v-if="customer"
      ref="loyaltyPointRecalculateDialog"
      :customer="customer"
      @success="transactions.reload()"
    />
  </panel-layout>
</template>
<script setup lang="ts">
import { LoyaltyTransactionTypeLabels } from '@/_api/models/customer'
// @ts-ignore
import LoyaltyPointBalanceDialog from '@/components/customer/actions/LoyaltyPointBalance.vue'
// @ts-ignore
import LoyaltyPointRecalculateDialog from '@/components/customer/actions/LoyaltyPointRecalculate.vue'

// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import {
  TablePager,
} from '@/_api/lib/pager'

// @ts-ignore
import {
  OPager,
  OTable,
  ODropdownItem,
} from '@/components/elements'

const props = defineProps<{ id?: string }>()

const { $api, $currency, $date, $i18n } = useNuxtApp()

const customer = ref<any>(null)
const transactions = ref<any>(new TablePager((page: any) => $api.customer.loyaltyTransactions(customer.value.idCustomer, { page }), 20))
const loading = ref(true)

const loyaltyPointBalanceDialog = ref<any>()
const loyaltyPointRecalculateDialog = ref<any>()

const heading = computed(() => {
  if (customer.value) {
    return `${$i18n.t('pages.customer.loyalty.id.transactions')}: ` + customer.value.displayName
  }

  return $i18n.t('pages.customer.loyalty.id.transactions')
})

const info = computed(() => {
  if (customer.value) {
    return `${$i18n.t('general.balance')}: ${customer.value.balances.loyaltyPoints || 0} (${customer.value.balances.loyaltyPointsInCurrencyLabel || 0})`
  }

  return ''
})

const formatAmount = (amount: any) => {
  return $currency.format(amount)
}

const formatDate = (date: any) => {
  return $date.format($date.local(date * 1000), $date.presets.full)
}

const handleLoyaltyPointBalance = () => {
  loyaltyPointBalanceDialog.value.open()
}

const handleLoyaltyPointRecalculate = () => {
  loyaltyPointRecalculateDialog.value.open()
}

const init = async (idCustomer?: string) => {
  loading.value = true
  try {
    if (idCustomer) {
      customer.value = (await $api.customer.get(idCustomer)).data

      if (transactions.value && customer.value) {
        transactions.value.load()
      }
    }
  } catch (e) {
    console.log(e)
  }
  loading.value = false
}

watch(() => props.id, (id) => init(id), { immediate: true })
</script>
